module.exports = __webpack_public_path__ + "static/img/main.6a4012a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main.jpg
// module id = LwnF
// module chunks = 0